<div class="screen-assignment">
  <div class="screen-header">
    <mat-checkbox [checked]="true" [disableRipple]="true" (change)="unselect()">
      <p class="item-title" [matTooltip]="screen.MonitorTitle">{{screen.MonitorTitle}}</p>
    </mat-checkbox>
  </div>

  <div class="playlist-content" *ngIf="screen.AssignedPlaylist">
    <mat-icon class="playlist-icon" svgIcon="playlist_play" matTooltip="Asisigned playlist"></mat-icon>
    <p class="item-title" [matTooltip]="screen.AssignedPlaylist?.PlaylistTitle">{{screen.AssignedPlaylist?.PlaylistTitle}}</p>
    <div class="float-right mt-1">
      <mat-icon (click)="screen.playAssigned()" *ngIf="screen.Status == screenStatuses.Waiting" class="action-button play"
        svgIcon="play_arrow" matTooltip="Start Playlist"></mat-icon>
      <mat-icon (click)="screen.stopPlaylist()" *ngIf="screen.Status == screenStatuses.Playing" class="action-button stop"
        svgIcon="stop" matTooltip="Stop Playlist"></mat-icon>
      <mat-spinner *ngIf="screen.Status == screenStatuses.Pending" [diameter]="20"></mat-spinner>
      <mat-icon (click)="screen.dismissPlaylist()" *ngIf="screen.Status == screenStatuses.Waiting && !isInPending" class="action-button"
        svgIcon="close" matTooltip="Remove assignment"></mat-icon>
    </div>
  </div>

</div>
